import SessionExpireModal from '~/authentication/sessions/components/session_expire_modal.vue';
import { getExpiringSamlSession } from '../saml_sessions';
export default {
    name: 'SamlReloadModal',
    components: {
        SessionExpireModal
    },
    props: {
        samlProviderId: {
            type: Number,
            required: true
        },
        samlSessionsUrl: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            sessionTimeout: null
        };
    },
    async created () {
        const session = await getExpiringSamlSession({
            samlProviderId: this.samlProviderId,
            url: this.samlSessionsUrl
        });
        if (session) {
            this.sessionTimeout = Date.now() + session.timeRemainingMs;
        }
    }
};
